import { AxiosError } from 'axios';
import instance from '../config/axios';

export const getPasswordResetUrl = async (accessToken: string) => {
  try {
    const response = await instance({
      url: '/api/v1/patient/reset/password',
      method: 'GET',
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    return response.data.data;
  } catch (e) {
    console.log('Error while retriving doctors', e);
    return (e as AxiosError).response?.status;
  }
};
